<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-ums__cashwithdrawal">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item v-if="visible">
                    <el-select v-model="dataForm.orgId" placeholder="请选择区域">
                        <el-option label="全选" value="" key=""></el-option>
                        <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.orgName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.verifyStatus" placeholder="请选择状态">
                        <el-option
                                v-for="item in allStatus"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="dataForm.cardType" placeholder="请选择卡好类型">
                        <el-option
                                v-for="item in cardTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.beginDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="开始时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.endDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="结束时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                <el-button v-if="$hasPermission('ums:cashwithdrawal:update')"
                           type="primary"  @click="batchUpdateHandle()">批量审核
                </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info"  @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:cashwithdrawal:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
                <!--        </el-form-item>-->
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:cashwithdrawal:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
                <!--        </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                 <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column prop="orgName" label="公司名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="cardType" label="卡号类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.cardType===0" size="small" type="success">银行卡</el-tag>
                        <el-tag v-else-if="scope.row.cardType===1" size="small" type="success">支付宝</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="bankCardNumber" label="卡号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="bankName" label="银行名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="bankAccountName" label="银行开户名" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="branch" label="开户支行" header-align="center" align="center"></el-table-column>
                <el-table-column prop="withdrawMoney" label="提现金额" header-align="center"
                                 align="center"></el-table-column>
                <!--        <el-table-column prop="serviceFee" label="服务费比例" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="note" label="备注" header-align="center" align="center"></el-table-column>
                <el-table-column prop="verifyStatus" label="审核状态" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.verifyStatus===1" size="small" type="success">待审核</el-tag>
                        <el-tag v-if="scope.row.verifyStatus===2" size="small" type="success">已通过</el-tag>
                        <el-tag v-if="scope.row.verifyStatus===3" size="small" type="success">已拒绝</el-tag>
                        <!--            <el-tag v-if="scope.row.verifyStatus===10" size="small" type="success">确认打款</el-tag>-->
                    </template>
                </el-table-column>
                <el-table-column prop="checkTime" label="审核时间" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="serviceId" label="操作人ID" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="serviceName" label="操作人姓名" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="deptId" label="部门ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>-->
                <el-table-column label="审核" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="$hasPermission('ums:cashwithdrawal:update')&&scope.row.verifyStatus==1"
                                   type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">审核
                        </el-button>
                        <!--            <el-button v-if="$hasPermission('ums:cashwithdrawal:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
            <BatchCheck v-if="batchCheckVisible" ref="BatchCheck"  @refreshDataList="getDataList"></BatchCheck>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './cashwithdrawal-add-or-update'
    import BatchCheck from './cashwithdrawal-batch-check'
    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                visible: false,
                batchCheckVisible:false,
                orgList: [],
                allStatus:[{
                    value: "",
                    label: ''
                },{
                    value: 1,
                    label: '待审核'
                },{
                    value: 2,
                    label: '已通过'
                },{
                    value: 3,
                    label: '已拒绝'
                }],
                cardTypeList:[{
                    value: "",
                    label: ''
                },{
                    value: 0,
                    label: '银行卡'
                },{
                    value: 1,
                    label: '支付宝账号'
                }],
                mixinViewModuleOptions: {
                    getDataListURL: '/ums/cashwithdrawal/page',
                    getDataListIsPage: true,
                    exportURL: '/ums/cashwithdrawal/export',
                    deleteURL: '/ums/cashwithdrawal',
                    deleteIsBatch: true,
                    activatedIsNeed: false
                },
                dataForm: {
                    mobileNumber: '',
                    memberName: '',
                    beginDate: "",
                    endDate:"",
                    verifyStatus: '',
                    cardType:'',
                    orgId: '',
                    orgName:'',
                    isHead:false,
                    withdrawalType:0,
                }
            }
        },
        created() {
            let d = new Date
            //d.setTime(d.getTime()-24*30*60*60*1000);
            d.setMonth(d.getMonth()-1);
            this.dataForm.beginDate=d
        },
        mounted() {
            const that = this;
            that.getInfo();
        },
        methods:{
            getInfo() {
                this.$http.get(`/sys/user/info`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.orgId=res.data.orgId
                    this.dataForm.orgName=res.data.orgName
                    this.dataForm.isHead=res.data.isHead;
                    if (this.dataForm.isHead) {
                        this.visible=true;
                        this.getOrgList();
                    }
                    if(!this.mixinViewModuleOptions.activatedIsNeed){
                        this.getDataList()
                    }
                }).catch(() => {
                })
            },
            batchUpdateHandle(){
                if ( this.dataListSelections.length <= 0) {
                    return this.$message({
                        message: '请选择会员账户提现申请项',
                        type: 'warning',
                        duration: 1000
                    })
                }
                for(let i=0;i<this.dataListSelections.length;i++) {
                    if(this.dataListSelections[i].verifyStatus!==1){
                        let accountName=this.dataListSelections[i].bankAccountName;
                        return this.$message({
                            message: accountName+'不为待审核阶段',
                            type: 'warning',
                            duration: 1000
                        })
                    }
                }
                let ids= this.dataListSelections.map(item => item[this.mixinViewModuleOptions.deleteIsBatchKey])
                this.batchCheckVisible = true
                this.$nextTick(() => {
                    this.$refs.BatchCheck.dataForm.ids = ids
                    this.$refs.BatchCheck.init()
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/select').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            }
        },
        components: {
            AddOrUpdate,
            BatchCheck
        }
    }
</script>
